import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/filter';
import * as $ from 'jquery';

@Component({
  selector: 'app-redes-sociales',
  templateUrl: './redes-sociales.component.html',
  styleUrls: ['./redes-sociales.component.scss']
})

export class RedesSocialesComponent implements OnInit {
  // mensaje para compartir en email
  descripcionEmail = "Compartir la infografía del Centro de Ayuda";
  href:string = "";
  constructor() { }

  ngOnInit() {
    $(document).ready(function(){
      $('#div-redes').click(function(){
        $('#div-redes').toggleClass('rs-cerrar');
        $('span').toggleClass('icono-movil');
        $('#ver-esconder').toggleClass('ver-iconos');
        $('#bloquear').toggleClass('bloquear');
      });
    });

    $('#cielo').click(
      function()
          {
                $('html,body').animate({scrollTop:'0px'}, 500);
                return false;
          }
    );
  }


  // Obtiene la ruta en la que se encuentra el usuario y la retorna la url al tag para poder compartir
  ruta():string {
     let r = window.location.href;
     return r;
     }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/redes-sociales/redes-sociales.component.ts